import { render, staticRenderFns } from "./supportTickets.vue?vue&type=template&id=15f8677a"
import script from "./supportTickets.vue?vue&type=script&lang=js"
export * from "./supportTickets.vue?vue&type=script&lang=js"
import style0 from "./supportTickets.vue?vue&type=style&index=0&id=15f8677a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports